import { css } from '@emotion/react';

export const logo = css`
  justify-self: end;
  max-height: 48px;
`;
